export default () => (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
